import React from "react";
import SEO from "../../SEO";
import "./Inventorysoftware.css";

export default function InventorySoftware() {
  const features = [
    { icon: "📦", text: "Real-Time Stock Tracking" },
    { icon: "🏷️", text: "Barcode & SKU Management" },
    { icon: "🏬", text: "Multi-Warehouse Support" },
    { icon: "🧾", text: "Purchase & Sales Management" },
    { icon: "⚠️", text: "Low Stock Alerts" },
    { icon: "🚚", text: "Supplier Management" },
    { icon: "📊", text: "Automated Reports" },
    { icon: "💳", text: "POS Integration" },
  ];

  const benefits = [
    { icon: "💰", text: "Reduce Inventory Loss" },
    { icon: "📈", text: "Improve Stock Accuracy" },
    { icon: "⚡", text: "Faster Business Operations" },
    { icon: "📡", text: "Real-Time Reporting" },
    { icon: "🧠", text: "Better Decision Making" },
    { icon: "🚀", text: "Scalable System for Growth" },
  ];

  const industries = [
    { icon: "💊", text: "Pharmacy Inventory Software" },
    { icon: "🛒", text: "Retail Inventory System" },
    { icon: "🏪", text: "Supermarket Management System" },
    { icon: "🏭", text: "Warehouse Management Software" },
    { icon: "🍽️", text: "Restaurant Stock System" },
    { icon: "👕", text: "Garments Inventory System" },
    { icon: "🚛", text: "Wholesale Distribution System" },
    { icon: "🛍️", text: "E-Commerce Inventory Tracking" },
  ];

  const faqs = [
    {
      q: "What is inventory management software?",
      a: "It is a system that helps businesses track stock, sales, purchases, and warehouse operations in real-time.",
    },
    {
      q: "Do you provide custom inventory software?",
      a: "Yes, we build fully customized inventory systems for retail, pharmacy, and warehouse businesses.",
    },
    {
      q: "Can it integrate with POS systems?",
      a: "Yes, our inventory software is fully integrated with POS and ERP systems.",
    },
    {
      q: "Is it suitable for multi-branch businesses?",
      a: "Yes, it supports multiple warehouses and branch-level stock management.",
    },
  ];

  return (
    <>
      <SEO
        title="Inventory Management Software | POS & ERP System Pakistan"
        description="Advanced inventory management software for retail, pharmacy, warehouse and business automation in Pakistan."
        url="https://mzrsoftware.com/inventory-software"
      />

      <div className="portfolio-section">
        {/* HERO */}
        <div className="section-header text-center mb-5">
          <h1 className="section-title">
            Inventory Management <span className="highlight">Software</span>
          </h1>

          <p className="section-subtitle">
            Powerful inventory tracking system for retail, pharmacy, warehouse
            and business automation with real-time stock control and reporting.
          </p>
        </div>

        {/* INTRO */}
        <section className="text-center mb-5">
          <h2>Introduction</h2>
          <p className="section-subtitle">
            Our inventory management software helps businesses automate stock
            control, reduce losses, and improve operational efficiency.
          </p>
        </section>

        {/* FEATURES */}
        <section className="mb-5">
          <h2 className="text-center mb-4">Features</h2>

          <div className="portfolio-grid">
            {features.map((item, i) => (
              <div key={i} className="portfolio-card text-center">
                <div className="card-content">
                  <div className="card-icon">{item.icon}</div>
                  <h3>{item.text}</h3>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* BENEFITS */}
        <section className="mb-5">
          <h2 className="text-center mb-4">Benefits</h2>

          <div className="portfolio-grid">
            {benefits.map((item, i) => (
              <div key={i} className="portfolio-card text-center">
                <div className="card-content">
                  <div className="card-icon">{item.icon}</div>
                  <h3>{item.text}</h3>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* SCREENSHOTS */}
        <section className="mb-5">
          <h2 className="text-center mb-4">Screenshots</h2>

          <div className="portfolio-grid">
            <div className="portfolio-card text-center">
              <div className="card-content">
                <h3>📊 Inventory Dashboard</h3>
              </div>
            </div>

            <div className="portfolio-card text-center">
              <div className="card-content">
                <h3>📦 Stock Management Panel</h3>
              </div>
            </div>

            <div className="portfolio-card text-center">
              <div className="card-content">
                <h3>📈 Sales & Purchase Reports</h3>
              </div>
            </div>
          </div>
        </section>

        {/* INDUSTRIES */}
        <section className="mb-5">
          <h2 className="text-center mb-4">Industries We Serve</h2>

          <div className="portfolio-grid">
            {industries.map((item, i) => (
              <div key={i} className="portfolio-card text-center">
                <div className="card-content">
                  <div className="card-icon">{item.icon}</div>
                  <h3>{item.text}</h3>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* FAQ */}
        <section className="mb-5">
          <h2 className="text-center mb-4">FAQs</h2>

          <div className="portfolio-grid">
            {faqs.map((item, i) => (
              <div key={i} className="portfolio-card">
                <div className="card-content">
                  <h3>{item.q}</h3>
                  <p>{item.a}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="portfolio-cta text-center mt-5">
          <h2>Start Your Inventory System Today</h2>

          <p className="cta-text">
            Get a powerful inventory management solution with real-time
            tracking, POS integration, and full automation.
          </p>

          <a href="/contact" className="btn-primary">
            Get Free Consultation →
          </a>
        </section>
      </div>
    </>
  );
}
